export default "__VITE_ASSET__BPZu0rAe__"